import { useContext } from "react";
import { ColorModeContext } from "contexts";

export default () => useContext(ColorModeContext);
